import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import uniqueId from 'lodash/uniqueId.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import CardTrigger from './trigger-types/card-trigger.vue.js';
import DetailsTrigger from './trigger-types/details-trigger.vue.js';
import PendoCollapseTransition from '../../utils/pendo-collapse-transition.vue.js';

var script = {
  name: 'CollapseItem',
  components: {
    CardTrigger,
    PendoCollapseTransition,
    DetailsTrigger,
    PendoIcon
  },
  inject: ['$collapse'],
  props: {
    collapsible: {
      type: Boolean,
      default: true
    },
    name: {
      type: [String, Number],
      default() {
        return this._uid;
      }
    },
    title: {
      type: String,
      default: null
    },
    activeTitle: {
      type: String,
      default: null
    },
    prefixIcon: {
      type: Object,
      default: null
    },
    suffixIcon: {
      type: [Object, Boolean],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null,
      validator: type => ['card', 'details'].includes(type)
    }
  },
  data() {
    return {
      isFocused: false,
      isClick: false,
      id: uniqueId()
    };
  },
  computed: {
    panelPrefixIcon() {
      return _objectSpread2(_objectSpread2({}, this.$collapse.panelHeaderProps.prefixIcon), this.prefixIcon);
    },
    panelSuffixIcon() {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, this.suffixIcon !== false && this.allowCollapse && {
        'type': 'chevron-down',
        'size': '14px',
        'stroke': '#6a6c75',
        'aria-hidden': true
      }), this.$collapse.panelHeaderProps.suffixIcon), this.suffixIcon);
    },
    titleContent() {
      if (this.isExpanded && this.activeTitle) {
        return this.activeTitle;
      }
      return this.title;
    },
    isExpanded() {
      return this.$collapse.model.indexOf(this.name) > -1;
    },
    allowCollapse() {
      return this.$collapse.forceAlwaysOpen && this.$collapse.forceAlwaysOpen.indexOf(this.name) === -1;
    },
    showPrefixIcon() {
      if (this.$slots.title) {
        return false;
      }
      return this.panelPrefixIcon && this.panelPrefixIcon.type;
    },
    showSuffixIcon() {
      if (!this.allowCollapse) {
        return false;
      }
      if (this.type) {
        return false;
      }
      return this.panelSuffixIcon && this.panelSuffixIcon.type;
    }
  },
  created() {
    if (this.expanded) {
      this.$collapse.handlePanelClick(this.name);
    }
  },
  methods: {
    handleFocus() {
      setTimeout(() => {
        if (!this.isClick) {
          this.isFocused = true;
        } else {
          this.isClick = false;
        }
      }, 50);
    },
    handleHeaderClick() {
      if (this.allowCollapse && !this.disabled && this.collapsible) {
        this.$collapse.handlePanelClick(this.name);
        this.isFocused = false;
        this.isClick = true;
      }
      this.$emit('click', this.name);
    },
    handleEnterKeydown() {
      if (this.allowCollapse && !this.disabled && this.collapsible) {
        this.$collapse.handlePanelClick(this.name);
      }
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-collapse-item.vue2.js.map
